import { render, staticRenderFns } from "./CursosProgramados.vue?vue&type=template&id=1a99dedd&scoped=true"
import script from "./CursosProgramados.vue?vue&type=script&lang=js"
export * from "./CursosProgramados.vue?vue&type=script&lang=js"
import style0 from "./CursosProgramados.vue?vue&type=style&index=0&id=1a99dedd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a99dedd",
  null
  
)

export default component.exports